import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Pass Editor</Typography>

      <p>Here you can process managed passes if you are unable to use the Scan App (eg. online purchases)</p>

    </div>
  )
}

export default HelpText